// Propósito: formateo de fechas del feature de leads. Se fuerza hour12: false
// porque el default de es-AR en algunos navegadores rinde 12 hs sin indicador
// a. m./p. m. ("16/9/2026, 04:25:40" para las 16:25).
export function formatDateTime24h(value: string | Date): string {
  return new Date(value).toLocaleString('es-AR', { hour12: false });
}
